// Phase I Wave 1.11 · Super-admin-only route guard · additive, zero-touch.
// Mirrors V12AdminOnlyRoute · tightens the check to `role === "super_admin"`.
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";

function _isSuperAdmin(role) {
    if (!role) return false;
    const r = String(role).toLowerCase();
    return r === "super_admin" || r === "superadmin";
}

export default function V12SuperAdminOnlyRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div
                className="min-h-screen bg-[#0D0D0D] flex items-center justify-center"
                data-testid="v12-super-admin-only-route-loading"
            >
                <span className="text-xs text-neutral-500 tracking-wide">
                    Caricamento…
                </span>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/" replace state={{ from: location.pathname }} />;
    }

    if (!_isSuperAdmin(user.role)) {
        // eslint-disable-next-line no-console
        console.warn(
            `[V12SuperAdminOnlyRoute] Access denied for role='${user.role}' on '${location.pathname}'.`,
        );
        return (
            <Navigate
                to="/app/dashboard?blocked=super_admin_only"
                replace
            />
        );
    }

    return children;
}
